export function shouldShowLearningExpirationMessage(expiredAt: Date): boolean {
  return getDaysUntilDate(expiredAt) <= 30;
}

export function getDaysUntilDate(d: Date): number {
  return Math.floor((d.getTime() - Date.now()) / (3600 * 1000 * 24));
}
